import { render, staticRenderFns } from "./AddActivity.vue?vue&type=template&id=3a15b3ad&scoped=true"
import script from "./AddActivity.vue?vue&type=script&lang=js"
export * from "./AddActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a15b3ad",
  null
  
)

export default component.exports